/**
 * @method getAllPagesInQueue
 * @param {Array}pageRangesQueue the current page ranges
 * @returns {Array} the page indexes + 1 from the page ranges
 */
const getAllPagesInQueue = (pageRangesQueue) => {
  if (!pageRangesQueue || !pageRangesQueue?.[0]) {
    return [];
  }

  return pageRangesQueue?.reduce((acc, pageRange) => {
    // BE is expecting index + 1
    pageRange.pages.forEach((page) => acc.push(page.index + 1));

    return acc;
  }, []);
};

export default getAllPagesInQueue;
